import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ShareIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsPhoneCss = "c1pr57k1";
const containerCss = "c12pf5qv";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const buttonContainerIsPhoneCss = "bmykis9";
const buttonContainerCss = "b1hxn2wj";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, {
    [buttonContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledBackButtonCss = "s1iq8aiy";
const StyledBackButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledBackButtonCss, props.className)} />);
const styledSendButtonCss = "s4x6jjd";
const StyledSendButton = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(styledSendButtonCss, props.className)} />);
export const Footer = ({
  onBack,
  isLoading
}) => <Container>
    <ButtonContainer>
      <StyledBackButton decoration="outline" onClick={onBack} loading={isLoading}>
        {I18n.t('publisher.contacts.buttons.back')}
      </StyledBackButton>
    </ButtonContainer>
    <ButtonContainer>
      <StyledSendButton decoration="primary" type="submit" loading={isLoading}>
        <ShareIcon spacingRight={4} />
        {I18n.t('publisher.contacts.buttons.send_email')}
      </StyledSendButton>
    </ButtonContainer>
  </Container>;

require("./footer.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");